import { createdATFilter } from 'modules/common/constants';

export const blockCauseFilters = [createdATFilter];
